(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', Settings);


    Settings.$inject = ['$scope', '$rootScope', '$window', '$location', 'SettingsService'];

    function Settings($scope, $rootScope, $window, $location, SettingsService) {

        var vm = this;

        vm.saving = false;
        vm.doPrompt = true;
        vm.tabs = ['basicinfo', 'apiintegrations', 'integratedcampaigns', 'customsegments'];
        vm.setTab = function (index) {
            $location.path(vm.tabs[index]);
        };

        if($location.path()=='/'){
            vm.setTab(0);
        }

        $scope.$on('$locationChangeSuccess', function () {
            vm.currentTab = $location.path().replace('/', '');
        });

        //handles the loading animation logic for route changes
        $rootScope.$on('$routeChangeStart', function () {
            vm.isRouteLoading = true;
        });

        $rootScope.$on('$routeChangeSuccess', function () {
            vm.isRouteLoading = false;
        });

        // prevents the user from instantly leaving the page if they have unsaved changes
        $window.addEventListener("beforeunload", function (event) {
            if (SettingsService.settingsChanged() && vm.doPrompt) {
                (event || $window.event).returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
            }
        });

        vm.changed = function () {
            return SettingsService.settingsChanged();
        };

        vm.saveSettings = function () {
            if (!vm.saving) {
                vm.saving = true;
                var waitToSave = SettingsService.saveSettings();
                waitToSave.then(
                    //on success
                    function () {
                        vm.saving = false;
                        vm.doPrompt = false;
                        $window.location.reload();
                    },
                    //on failure
                    function (response) {
                        vm.saving = false;
                        var message;
                        if (!angular.isUndefined(response.data.message)) {
                            message = response.data.message;
                        }
                        else if (!angular.isUndefined(response.data.adform.message)) {
                            message = response.data.adform.message;
                        }
                        Notification.showSimpleError(message, 'Request failed');
                    });
            }
        };
    }
})();
